/**
 * @title 我的课程
 */
export default [
  // 互动课件
  {
    path: '/dataIndex',
    name: '资料详情',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/data/index.vue')
  },
  {
    path: '/courseShare',
    name: '分享课程 ',
    component: () => {
      return import(/* webpackChunkName: "courseShare" */ '@/views/course/courseShare/courseShare.vue');
    }
  },
  // 互动课件详情
  {
    path: '/courseware/detail',
    name: '课件详情',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/index.vue')
  },
  // 课件预览
  {
    path: '/courseware/view',
    name: '课件预览',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/coursewareView/coursewareView.vue')
  },
  // 学生列表
  {
    path: '/courseware/studentList',
    name: '',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/studentList/studentList.vue')
  },
  // 讨论详情页
  {
    path: '/courseware/discuss',
    name: '讨论',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/discuss/coursewareDiscuss.vue')
  },
  // 开始学习-学生
  {
    path: '/courseware/startLearning',
    name: '开始学习',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/startLearning/startLearning.vue'),
    meta: {
      keepAlive: true
    }
  },
  // 导入文件
  {
    path: '/courseware/importFile',
    name: 'ImportFile',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/importFile/index.vue')
  },
  // 批阅互动课件
  {
    path: '/reviewCourseWare',
    name: 'ReviewCourseWare',
    component: () => import(/* webpackChunkName: "courseware" */ '@/views/course/courseware/reviewCourseWare/reviewCourseWare.vue')
  }
];
